// eslint-disable-next-line no-extend-native
String.prototype.truncate = function (max) {
    return (
        <>
            {
                this.substr(0,max -1)
            }
            {
                this.length > max ?
                    <>&hellip;</> :
                    ''
            }
        </>
    )
}
// eslint-disable-next-line no-extend-native
Object.defineProperty(String.prototype, 'capitalize', {
    value: function () {
        return this.charAt(0).toUpperCase() + this.slice(1)
    },
    enumerable: false
})